import React from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
export default function OnlineVideoPlayer() {
  return (
    <div>
      <NavBar />
      OnlineVideoPlayer
      <Footer />
    </div>
  );
}
